import {
  getDistinctBlocks,
  getDistinctClusters,
  getDistinctCountries,
  getDistinctDistricts,
  getDistinctGradesNames,
  getDistinctSchoolGroups,
  getDistinctSchoolIds,
  getDistinctSessionNames,
  getDistinctStates,
} from 'clients/FilterClients';
import { useSlideContainerStore } from 'ppt_slides/store/slideStore';
import { useEffect } from 'react';
import { useApiLoaderStore } from 'store/apiLoderStore';
import { useFilterStore } from 'store/filterStore';
import { useToastStore } from 'store/toastStore';
import MultiSelector from './MultiSelector';

type Props = {
  isOpen: boolean;
  startDate: number;
  endDate: number;
  selectedDataSouce: string;
  setIsOpen: (param: boolean) => void;
};
function FilterContent(props: Props) {
  const { isOpen, startDate, endDate, selectedDataSouce, setIsOpen } = props;
  const showLoader = useApiLoaderStore((state) => state.showLoader);
  const [
    setFilterDto,
    resetFilterStore,
    countryList,
    stateList,
    districtList,
    blockList,
    clusterList,
    schoolGroupList,
    sessionNameList,
    schoolIdList,
    gradeList,
    setCountryList,
    setStateList,
    setDistrictList,
    setBlockList,
    setClusterList,
    setSchoolGroupList,
    setSessionNameList,
    setSchoolIdList,
    setGradeList,
  ] = useFilterStore((state) => [
    state.setFilterDto,
    state.resetStore,
    state.countryList,
    state.stateList,
    state.districtList,
    state.blockList,
    state.clusterList,
    state.schoolGroupList,
    state.sessionNameList,
    state.schoolIdList,
    state.gradeList,
    state.setCountryList,
    state.setStateList,
    state.setDistrictList,
    state.setBlockList,
    state.setClusterList,
    state.setSchoolGroupList,
    state.setSessionNameList,
    state.setSchoolIdList,
    state.setGradeList,
  ]);
  const [
    selectedCountries,
    selectedStates,
    selectedDistricts,
    selectedBlocks,
    selectedClusters,
    selectedSchoolGroups,
    selectedSessionNames,
    selectedSchoolIds,
    selectedGrades,
    setSelectedCountries,
    setSelectedStates,
    setSelectedDistricts,
    setSelectedBlocks,
    setSelectedClusters,
    setSelectedSchoolGroups,
    setSelectedSessionNames,
    setSelectedSchoolIds,
    setSelectedGrades,
  ] = useFilterStore((state) => [
    state.selectedCountries,
    state.selectedStates,
    state.selectedDistricts,
    state.selectedBlocks,
    state.selectedClusters,
    state.selectedSchoolGroups,
    state.selectedSessionNames,
    state.selectedSchoolIds,
    state.selectedGrades,
    state.setSelectedCountries,
    state.setSelectedStates,
    state.setSelectedDistricts,
    state.setSelectedBlocks,
    state.setSelectedClusters,
    state.setSelectedSchoolGroups,
    state.setSelectedSessionNames,
    state.setSelectedSchoolIds,
    state.setSelectedGrades,
  ]);
  const [resetSlideStore] = useSlideContainerStore((state) => [
    state.resetStore,
  ]);
  const showToast = useToastStore((state) => state.showToast);
  useEffect(() => {
    const params = {
      startDate,
      endDate,
      dataSource: selectedDataSouce,
    };
    getDistinctSessionNames(params, showToast).then((response) => {
      if (response) {
        const sessions = response.map((filterDto: any) => filterDto.entity);
        setSessionNameList(sessions);
      } else {
        setSessionNameList([]);
      }
    });
  }, [showToast, startDate, endDate, selectedDataSouce, setSessionNameList]);
  useEffect(() => {
    if (selectedSessionNames.length > 0) {
      const params = {
        selectedSessionNames,
        startDate,
        endDate,
        dataSource: selectedDataSouce,
      };
      showLoader(true);
      getDistinctCountries(params, showToast).then((response) => {
        showLoader(false);
        if (response) {
          const countries = response.map((filterDto: any) => filterDto.entity);
          setCountryList(countries);
        } else {
          setCountryList([]);
        }
      });
    }
  }, [
    showToast,
    startDate,
    endDate,
    selectedDataSouce,
    setCountryList,
    selectedSessionNames,
    showLoader,
  ]);
  useEffect(() => {
    if (selectedSessionNames.length > 0 && selectedCountries.length > 0) {
      const params = {
        selectedSessionNames,
        selectedCountries,
        startDate,
        endDate,
        dataSource: selectedDataSouce,
      };
      showLoader(true);
      getDistinctStates(params, showToast).then((response) => {
        showLoader(false);
        if (response) {
          const states = response.map((filterDto: any) => filterDto.entity);
          setStateList(states);
        }
      });
    } else {
      setStateList([]);
    }
  }, [
    showToast,
    startDate,
    endDate,
    selectedDataSouce,
    selectedSessionNames,
    selectedCountries,
    setStateList,
    showLoader,
  ]);
  useEffect(() => {
    if (
      selectedSessionNames.length > 0 &&
      selectedCountries.length > 0 &&
      selectedStates.length > 0
    ) {
      const params = {
        selectedSessionNames,
        selectedCountries,
        selectedStates,
        startDate,
        endDate,
        dataSource: selectedDataSouce,
      };
      showLoader(true);
      getDistinctDistricts(params, showToast).then((response) => {
        showLoader(false);
        if (response) {
          const districts = response.map((filterDto: any) => filterDto.entity);
          setDistrictList(districts);
        }
      });
    } else {
      setDistrictList([]);
    }
  }, [
    showToast,
    startDate,
    endDate,
    selectedDataSouce,
    selectedSessionNames,
    selectedCountries,
    selectedStates,
    setDistrictList,
    showLoader,
  ]);
  useEffect(() => {
    if (
      selectedSessionNames.length > 0 &&
      selectedCountries.length > 0 &&
      selectedStates.length > 0 &&
      selectedDistricts.length > 0
    ) {
      const params = {
        selectedSessionNames,
        selectedCountries,
        selectedStates,
        selectedDistricts,
        startDate,
        endDate,
        dataSource: selectedDataSouce,
      };
      showLoader(true);
      getDistinctBlocks(params, showToast).then((response) => {
        showLoader(false);
        if (response) {
          const blocks = response.map((filterDto: any) => filterDto.entity);
          setBlockList(blocks);
        }
      });
    } else {
      setBlockList([]);
    }
  }, [
    showToast,
    startDate,
    endDate,
    selectedDataSouce,
    selectedSessionNames,
    selectedCountries,
    selectedStates,
    selectedDistricts,
    setBlockList,
    showLoader,
  ]);
  useEffect(() => {
    if (
      selectedSessionNames.length > 0 &&
      selectedCountries.length > 0 &&
      selectedStates.length > 0 &&
      selectedDistricts.length > 0 &&
      selectedBlocks.length > 0
    ) {
      const params = {
        selectedSessionNames,
        selectedCountries,
        selectedStates,
        selectedDistricts,
        selectedBlocks,
        startDate,
        endDate,
        dataSource: selectedDataSouce,
      };
      showLoader(true);
      getDistinctClusters(params, showToast).then((response) => {
        showLoader(false);
        if (response) {
          const clusters = response.map((filterDto: any) => filterDto.entity);
          setClusterList(clusters);
        }
      });
    } else {
      setClusterList([]);
    }
  }, [
    showToast,
    startDate,
    endDate,
    selectedDataSouce,
    selectedSessionNames,
    selectedCountries,
    selectedStates,
    selectedDistricts,
    selectedBlocks,
    setClusterList,
    showLoader,
  ]);
  useEffect(() => {
    if (
      selectedSessionNames.length > 0 &&
      selectedCountries.length > 0 &&
      selectedStates.length > 0
    ) {
      const params = {
        selectedSessionNames,
        selectedCountries,
        selectedStates,
        selectedDistricts,
        selectedBlocks,
        selectedClusters,
        startDate,
        endDate,
        dataSource: selectedDataSouce,
      };
      showLoader(true);
      getDistinctSchoolGroups(params, showToast).then((response) => {
        showLoader(false);
        if (response) {
          const schoolGroups = response.map(
            (filterDto: any) => filterDto.entity
          );
          setSchoolGroupList(schoolGroups);
        }
      });
    } else {
      setSchoolGroupList([]);
    }
  }, [
    showToast,
    startDate,
    endDate,
    selectedDataSouce,
    selectedSessionNames,
    selectedCountries,
    selectedStates,
    selectedDistricts,
    selectedBlocks,
    selectedClusters,
    setSchoolGroupList,
    showLoader,
  ]);
  useEffect(() => {
    if (
      selectedSessionNames.length > 0 &&
      selectedSessionNames.length > 0 &&
      selectedCountries.length > 0 &&
      selectedStates.length > 0 &&
      selectedSchoolGroups.length > 0
    ) {
      const params = {
        selectedSessionNames,
        selectedCountries,
        selectedStates,
        selectedDistricts,
        selectedBlocks,
        selectedClusters,
        selectedSchoolGroups,
        startDate,
        endDate,
        dataSource: selectedDataSouce,
      };
      showLoader(true);
      getDistinctSchoolIds(params, showToast).then((response) => {
        showLoader(false);
        if (response) {
          const schoolIds = response.map((filterDto: any) => filterDto.entity);
          setSchoolIdList(schoolIds);
        }
      });
    } else {
      setSchoolIdList([]);
    }
  }, [
    showToast,
    startDate,
    endDate,
    selectedDataSouce,
    selectedSessionNames,
    selectedCountries,
    selectedStates,
    selectedSchoolGroups,
    setSchoolIdList,
    showLoader,
  ]);
  useEffect(() => {
    if (selectedSchoolIds.length > 0) {
      const params = {
        selectedSchoolIds,
        startDate,
        endDate,
        dataSource: selectedDataSouce,
      };
      showLoader(true);
      getDistinctGradesNames(params, showToast).then((response) => {
        showLoader(false);
        if (response) {
          const grades = response.map((filterDto: any) => filterDto.entity);
          setGradeList(grades);
        }
      });
    } else {
      setGradeList([]);
    }
  }, [
    showToast,
    startDate,
    endDate,
    selectedDataSouce,
    selectedSchoolIds,
    setGradeList,
    showLoader,
  ]);
  return (
    <div
      className="filter-outer-container"
      style={{ display: isOpen ? 'block' : 'none' }}
    >
      <div className="header-container">
        <label>Filter</label>
        <img
          src="/images/x.svg"
          alt=""
          onClick={() => setIsOpen(false)}
          style={{ cursor: 'pointer' }}
        />
      </div>
      <div
        className="flex-column w-100 gap-12px p-1rem"
        style={{
          marginTop: '1rem',
          height: 'calc(100% - 9rem)',
          overflow: 'auto',
        }}
      >
        <MultiSelector
          selectionItems={sessionNameList ? sessionNameList : []}
          placeHolder={'Select Session'}
          selectedItems={selectedSessionNames}
          setSelectedItems={setSelectedSessionNames}
        />
        <MultiSelector
          selectionItems={countryList ? countryList : []}
          placeHolder={'Select Country'}
          selectedItems={selectedCountries}
          setSelectedItems={setSelectedCountries}
        />
        <MultiSelector
          selectionItems={stateList ? stateList : []}
          placeHolder={'Select State'}
          selectedItems={selectedStates}
          setSelectedItems={setSelectedStates}
        />
        <MultiSelector
          selectionItems={districtList ? districtList : []}
          placeHolder={'Select District'}
          selectedItems={selectedDistricts}
          setSelectedItems={setSelectedDistricts}
        />
        <MultiSelector
          selectionItems={blockList ? blockList : []}
          placeHolder={'Select Block'}
          selectedItems={selectedBlocks}
          setSelectedItems={setSelectedBlocks}
        />
        <MultiSelector
          selectionItems={clusterList ? clusterList : []}
          placeHolder={'Select Cluster'}
          selectedItems={selectedClusters}
          setSelectedItems={setSelectedClusters}
        />
        <MultiSelector
          selectionItems={schoolGroupList ? schoolGroupList : []}
          placeHolder={'Select SchoolGroup'}
          selectedItems={selectedSchoolGroups}
          setSelectedItems={setSelectedSchoolGroups}
        />
        <MultiSelector
          selectionItems={schoolIdList ? schoolIdList : []}
          placeHolder={'Select SchoolIds'}
          selectedItems={selectedSchoolIds}
          setSelectedItems={setSelectedSchoolIds}
        />
        <MultiSelector
          selectionItems={gradeList ? gradeList : []}
          placeHolder={'Select Grades'}
          selectedItems={selectedGrades}
          setSelectedItems={setSelectedGrades}
        />
      </div>
      <div
        className="flex-align-center p-1rem gap-1rem"
        style={{
          borderTop: '1px solid lightgray',
          justifyContent: 'flex-end',
        }}
      >
        <label
          className="filter-clearall-label"
          onClick={() => {
            resetSlideStore();
            resetFilterStore();
          }}
        >
          Clear all
        </label>
        <label className="filter-apply-label" onClick={() => setFilterDto()}>
          Apply
        </label>
      </div>
    </div>
  );
}

export default FilterContent;
